export const PROTOCOL_CREATE = 'PROTOCOL_CREATE';
export const PROTOCOL_DELETE = 'PROTOCOL_DELETE';
export const PROTOCOL_CHANGE_STATUS = 'PROTOCOL_CHANGE_STATUS';
export const EDITABLE_PROTOCOL_SET = 'EDITABLE_PROTOCOL_SET';
export const EDITABLE_PROTOCOL_CLEAR = 'EDITABLE_PROTOCOL_CLEAR';

export const PROTOCOL_LIST_CREATE = 'PROTOCOL_LIST_CREATE';